export default __webpack_public_path__ + "static/media/nekos-api-logo.ad2de35d.svg";